import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class ChangePasswordRequest
{
	public username: string;
	public currentPassword: string;
	public newPassword: string;

	public constructor(username: string, currentPassword: string, newPassword: string)
	{
		this.username = username;
		this.currentPassword = currentPassword;
		this.newPassword = newPassword;
	}
}

export interface ChangePasswordResult
{
    successful: boolean;
    message: string;
}

@Injectable()
export class SharedPasswordRepository
{
	private requestMapping: string = "password";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public changePassword(transfers: ChangePasswordRequest): Observable<ChangePasswordResult>
	{
		return this.http.put<ChangePasswordResult>(`${this.requestMapping}`, transfers);
	}
}
